module.exports = __webpack_public_path__ + "static/media/snowmobile.0949863c.svg";